import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=6fbf3bee&scoped=true&"
import script from "./Branch.vue?vue&type=script&lang=js&"
export * from "./Branch.vue?vue&type=script&lang=js&"
import style0 from "./Branch.vue?vue&type=style&index=0&id=6fbf3bee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf3bee",
  null
  
)

component.options.__file = "Branch.vue"
export default component.exports